var map = {
	"./role-consultant-agency-icon.svg": "54lJ",
	"./role-designer-icon.svg": "Gjh2",
	"./role-founder-ceo-icon.svg": "PLia",
	"./role-it-developer-icon.svg": "0sFr",
	"./role-manager-icon.svg": "5LRK",
	"./role-marketer-icon.svg": "RUrD",
	"./role-other-icon.svg": "rFSw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RoFO";